export abstract class Item{
    id: string;
    top: number;
    left: number;
    width: number;
    height: number;
    index: number;
    selected: boolean;

    constructor(id?: string, x?: number, y?: number, w?: number, h?: number){
      this.id = id;
      this.left = x>-1 ? x : 0;
      this.top = y>-1 ? y : 0;
      this.width = w>-1 ? w : 100;
      this.height = h>-1 ? h : 100;
    }

    getId(): string{
        return this.id;
    }

    getLeft(): number{
      return this.left;
    }
    getTop(): number{
      return this.top;
    }
    getWidth(): number{
      return this.width;
    }
    getHeight(): number{
      return this.height;
    }

    setLeft(nx: number){
      this.left = nx;
    }
    setTop(ny: number){
      this.top = ny;
    }
    setWidth(nw: number){
      this.width = nw;
    }
    setHeight(nh: number){
      this.height = nh;
    }

    setIndex(i: number){
        this.index = i;
    }
    getIndex(): number{
        return this.index;
    }
    setSelected(s: boolean): void{
        this.selected = s;
    }

    isSelected(): boolean{
        return this.selected;
    }
  }


export class Background{
    imageData: string;
    imagePreview: any;
    constructor(preview?: any, data?: string){
        this.imagePreview = preview;
        this.imageData = data;
    }
}

export class TextItem extends Item{
    content: string;
    fontFamily: string;
    fontSize: number;
    align: string;
    weight: string;
    style: string;
    color: string;
    innerHeight: number;
    type= "text";

    constructor(id?: string, x?: number, y?: number, w?: number, h?: number, content?: string, ffam?: string, fsize?: number, align?: string, weight?: string, style?: string, color?: string, innerHeight?: number){
        super(id, x, y, w, h);
        this.content = content;
        this.fontFamily = ffam;
        this.fontSize = fsize;
        this.align = align
        this.weight = weight;
        this.style = style;
        this.color = color;
        this.innerHeight = innerHeight;
    }

    getContent(): string{
        return this.content;
    }

    setContent(c: string): void{
        this.content = c;
    }

    getFontFamily(): string{
        return this.fontFamily;
    }
    setFontFamily(ff: string): void{
        this.fontFamily = ff;
    }

    getFontSize(): number{
        return this.fontSize;
    }
    setFontSize(fs: number): void{
        this.fontSize = fs;
    }

    getAlign(): string{
        return this.align;
    }
    setAlign(a: string): void{
        this.align = a;
    }

    getWeight(): string{
        return this.weight;
    }
    setWeight(w: string): void{
        this.weight = w;
    }

    getStyle(): string{
        return this.style;
    }
    setStyle(s: string): void{
        this.style = s;
    }

    getColor(): string{
      return this.color;
    }

    setColor(s: string): void{
      this.color = s;
    }
}

export class ClipartItem extends Item{
    imageUrl: string;
    imagePreview: any;
    imageData: string;
    type="clipart";
    constructor(id?: string, x?: number, y?: number, w?: number, h?: number, url?: string, data?: string){
        super(id, x, y, w, h);
        this.imagePreview = url;
        this.imageData = data;
    }

    getImageURL(): string{
        return this.imageUrl;
    }
}

export class VideoPoster{
    width: number;
    height: number;
    background: Background;
    items: Item[];
    selectedItemID: string;
    canvasScale: number;

    constructor(w?: number, h?: number, background?: Background){
        this.width = w;
        this.height = h;
        this.background = background;
        this.items = [];
        this.canvasScale = 1;
    }

    getWidth(): number{
        return this.width;
    }
    getHeight(): number{
        return this.height;
    }

    addItem(i: Item): void{
        var temp = this.getItems();
        if(temp.length > 0){
            i.setIndex(temp[temp.length-1].getIndex()+1);
        } else{
            i.setIndex(1);
        }
        this.items.push(i);
    }

    removeItem(id: string): boolean{
        var i = this.items.findIndex(item => item.getId() == id);
        if(i >-1) {
            this.items.splice(i, 1);
            return true;
        } else{
            return false;
        }
    }

    getItem(id: string): Item{
        var i = this.items.findIndex(item => item.getId() == id);
        if(i >-1) {
            return this.items[i];
        } else{
            return null;
        }
    }

    getItems(): Item[]{
        this.items = this.items.sort((i1, i2) => {
            if(i1.getIndex()<i2.getIndex()){
                return -1;
            }
            return 1;
        });
        return this.items;
    }

    getItemSelected(): Item{
        var i = this.items.findIndex(item => item.isSelected());
        if(i>-1){
            return this.items[i];
        } else{
            return null;
        }
    }
    removeItemSelected(): boolean{
        var i = this.items.findIndex(item => item.isSelected());
        if(i>-1){
            this.items[i].setSelected(false);
            return true;
        } else{
            return false;
        }
    }
    setItemSelected(id: string): void{
        this.removeItemSelected();
        var i = this.items.findIndex(item => item.getId() == id);
        if( i > -1){
            this.items[i].setSelected(true);
        }
    }
    getBackground(): Background{
        return this.background;
    }

    getNewItemID(): string{
        var temp = this.getItems();
        if(temp.length > 0){
            return "item"+ (temp[temp.length-1].getIndex() + 1);
        }
        return "item1";
    }

    static getVideoPosterFromJSON(data: any, sanitizer: any): VideoPoster{
        let bg = new Background(sanitizer.bypassSecurityTrustResourceUrl(data['background'].imageData), data['background'].imageData);
        let vp = new VideoPoster(data['width'], data['height'], bg);
        var items = data['items'];
        for(var i in items){
            if(items[i]['type'] == 'clipart'){
                var clip = new ClipartItem(items[i]['id'], items[i]['left'], items[i]['top'], items[i]['width'], items[i]['height'],
                                           sanitizer.bypassSecurityTrustResourceUrl(items[i]['imageData']), items[i]['imageData']);
                clip.setIndex(items[i]['index']);
                vp.items.push(clip);
            } else{
                var txt = new TextItem(items[i]['id'], items[i]['left'], items[i]['top'], items[i]['width'], items[i]['height'],
                                       items[i]['content'], items[i]['fontFamily'], items[i]['fontSize'], items[i]['align'],
                                       items[i]['weight'], items[i]['style'], items[i]['color'], items[i]['innerHeight']);
                txt.setIndex(items[i]['index']);
                vp.items.push(txt);
            }
        }
        return vp;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/videoposter.ts